import { Component, Input, OnInit } from '@angular/core';
import { allInvestmentDurations, VehicleValuation } from '@common/core/models';
import { AppSessionService } from '@web/core/services';

@Component({
  selector: 'cci-vehicle-calculator',
  templateUrl: './vehicle-calculator.component.html',
  styleUrls: ['./vehicle-calculator.component.scss'],
})
export class VehicleCalculatorComponent implements OnInit {
  @Input() vehicleValuation: VehicleValuation;
  allInvestmentDurations = allInvestmentDurations;

  constructor(public appSessionService: AppSessionService) {}

  ngOnInit(): void {}
}
